var _ = require('underscore');
var Backbone = require('backbone');
var Marionette = require('marionette');
var Activity = require('RecordActivityLog');
var Dialog = require('Dialog');
var Entities = require('Entities');
var UserLookup = require('UserLookup');
var Labels = EY.Consultation.Labels;
var Lookups = EY.Consultation.Lookups;
var Roles = new Backbone.Collection(EY.Consultation.Resources.Roles);

var View = Marionette.View.extend({
    regions: {
        user: '#user'
    },
    ui: {
        picklist: '#picklist'
    },
    template: '#recordActionPreparation',
    onRender: function () {
        var record = this.options.record;
        var role = Roles.get('Reviewer');
        var count = role.get('geographyTypePath').slice(1, -1).split('/').length;
        var geographyId = '/' + _.take(record.get('geographyId').slice(1, -1).split('/'), count).join('/') + '/';
        var picklist = new Entities.Users();

        UserLookup.show({
            region: this.getRegion('user'),
            user: this.model,
            collection: picklist
        });

        picklist.fetch({
            filter: { $or: [{ roles: { $elemMatch: { geographyId: geographyId, roleId: 'CountryProfessionalPractice' } }, active: true }, { roles: { $elemMatch: { geographyId: geographyId, roleId: 'Reviewer' } }, active: true }] },
            select: { active:1, displayName: 1, email: 1, geography: 1, givenName: 1, gpn: 1, id:1, mailNickname: 1, modifiedBy: 1, modifiedOn: 1, upn: 1,
                physicalDeliveryOfficeName: 1, givenName: 1, roles: { $elemMatch: { $or: [{ geographyId: geographyId, roleId: 'Reviewer' }, { geographyId: geographyId, roleId: 'CountryProfessionalPractice' }] } } }
        });

    }
});

module.exports.run = function (options) {
    var record = options.record;
    var user = new Entities.Approver({ id: 1, rank: 1 });

    return Dialog.show({
        cancelLabel: Labels.No,
        headerLabel: Labels.DialogTitleWarning,
        saveLabel: Labels.Yes,
        validate: user,
        modalBodyClass:'suggestion-modal',
        view: new View({
            model: user,
            record: record
        })
    }).done(function () {
        if (record.get('statusTypeId') == Lookups.StatusType.Preparation) {
            Activity.log(_.extend({ text: Labels.Activity_ReassignAtReviewer }, options));
        }
        record.set({
            assignedTo: user.get('upn'),
            assignedToGivenName: user.get('givenName'),
            statusResourceKey: Lookups.StatusType.Preparation,
            statusTypeId: Lookups.StatusType.Preparation
        });
    });
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Action/RecordActionPreparation.js